export default __webpack_public_path__ + "static/media/policy-outline-16px.b9422433.svg";